module.exports = __webpack_public_path__ + "img/686.db2f74db.png";